<template>
	<div id="productCenter">
		<page-header></page-header>
		<product-center-pc v-if="deviceType == 'pc'"></product-center-pc>
		<product-center-mobile v-if="deviceType == 'mobile'"></product-center-mobile>
		<page-footer></page-footer>
	</div>
</template>

<script>
	import PageHeaderComponents from "@/components/PageHeader.vue"
	import ProductCenterPC from "./ProductCenterPC.vue"
	import ProductCenterMobile from "./ProductCenterMobile.vue"
	import PageFooterComponents from "@/components/PageFooter.vue"
	export default {
		name: 'ProductCenter',
		components:{
			"page-header": PageHeaderComponents,
			"product-center-pc": ProductCenterPC,
			"product-center-mobile": ProductCenterMobile,
			"page-footer": PageFooterComponents
		},
		data() {
			return {
				deviceType: ""
			}
		},
		methods: {
			deviceTypeChangeFun() {
				this.deviceType = this.$store.state.deviceType;
			}
		},
		created() {
			this.deviceTypeChangeFun();
		},
		computed: {
			getDeviceTypeFun: function() {
				return this.$store.state.deviceType;
			}
		},
		watch: {
			getDeviceTypeFun() {
				this.deviceTypeChangeFun();
			}
		}
	}
</script>
